import { Typography } from '@mui/material';
import React from 'react';
import { Tab, tabs } from './TabbedSection';
import './TabRow.scss';

interface TabRowProps {
  tab: Tab;
  isSelected: boolean;
  selectTab: (tab: Tab) => any;
}

function TabRow({ tab, isSelected, selectTab }: TabRowProps) {
  return (
    <div
      className={`tab-row ${isSelected ? 'selected' : ''}`}
      onClick={() => selectTab(tab)}
    >
      <Typography variant="h6">{tabs[tab]}</Typography>
    </div>
  );
}

export default TabRow;
